import { useEffect, useRef, useState } from "react";
import { requestScope } from "../api/scope.js";

/** A synchronous lock blocks double submissions; account/recovery generations reject obsolete UI callbacks. */
export function useAdminAction() {
  const lock = useRef(false);
  const mounted = useRef(true);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [confirmed, setConfirmed] = useState(false);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const run = async (work: () => Promise<void>) => {
    if (lock.current) return;
    const generation = requestScope().generation;
    lock.current = true; setPending(true); setError(null); setConfirmed(false);
    try { await work(); if (mounted.current && requestScope().generation === generation) setConfirmed(true); }
    catch (e) { if (mounted.current && requestScope().generation === generation) setError(e instanceof Error ? e.message : String(e)); }
    finally { lock.current = false; if (mounted.current && requestScope().generation === generation) setPending(false); }
  };
  return { pending, error, confirmed, run };
}
